import './ConfigurazioneSito.css';
import React, { useState, useEffect } from 'react';
import API from '../../library/ApiManager';
import Fnc from '../../library/Functions';
import Loader from "react-loader-spinner";
import DialogMsg from '../DialogMsg';

function ConfigurazioneSito(props) {

  const [domainOk, setDomainOk] = useState(null);
  const [selectedExt, setSelectedExt] = useState(".it");
  const [currDomain, setCurrDomain] = useState(null);
  const [relatedDomains, setRelatedDomains] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dlgConf, setDlgConf] = useState(null);

  const extDomainsAvailable = [".it", ".com", ".org", ".eu", ".info", ".net", ".biz"];


  useEffect(() => {
    // Similar to componentDidMount and componentDidUpdate:
  }, []); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento


  function onDomainChange(e) {
    let val = e.target.value;
    setCurrDomain(val);
  }

  function onSelExtension(e) {
    let val = e.target.value;
    setSelectedExt(val);
  }

  function btnCheckClick() {
    let domain = "https://www." + currDomain + selectedExt;
    checkDomain(domain);
  }

  function checkDomain(domain) {

    if (domain && domain !== null && domain.length > 0) {
      setLoading(true);
      API.checkDomain(domain, (data) => {
        let isOk = data && data.response && data.response.code === 'AVAILABLE';
        setDomainOk(isOk);

        let relDoms = [];
        if (data && data.domain) {
          data.domain.forEach(dom => {
            let domParts = dom.split('.');
            let obj = {};
            obj.name = domParts[0];
            obj.ext = domParts[1];
            relDoms.push(obj);
          });
        }
        setRelatedDomains(relDoms);

        setLoading(false);
      });

    }

  }

  function gotoNext() {
    setDlgConf(null);

    if (currDomain && currDomain !== null && currDomain.length > 0 && selectedExt && selectedExt !== null && selectedExt.length > 0) {
      let domain = currDomain + selectedExt;

      API.basketValidation((bsk) => {

        if (bsk && bsk.response && bsk.response.code === 'OK') {

          if (bsk.basket && bsk.basket.product && bsk.basket.product.length > 0) {

            bsk.basket.product.forEach(prod => {
              if (prod.code === 'SDIY' || prod.code === 'DOMIN') {
                if (!prod.properties || prod.properties === null) {
                  prod.properties = {};
                }
                prod.properties.domain = domain;
              }
            });

            API.updateBasket(bsk.basket.product, (data) => {

              if (data && data.response && data.response.code === 'OK') {
                props.callback(new Fnc.Ret(Fnc.EnmGen.OK));
              } else {
                props.callback(new Fnc.Ret(Fnc.EnmGen.KO));
              }

            });

          } else {
            setDlgConf(new Fnc.DlgConf("[NOPRD] Errore", "Non è stato possibile salvare il dominio, non ci sono prodotti nel basket.", true, "Chiudi", ""));
            Fnc.gaException("[ConfigurazioneSito.js@gotoNext] Impossibile salvare il dominio", JSON.stringify(bsk), true, Fnc.ExcCatgory.DOMAIN.val);
          }

        } else {
          setDlgConf(new Fnc.DlgConf("[SRVKO] Errore", "Non è stato possibile salvare il dominio.", true, "Chiudi", ""));
          Fnc.gaException("[ConfigurazioneSito.js@gotoNext] Impossibile salvare il dominio, codice KO", JSON.stringify(bsk), true, Fnc.ExcCatgory.DOMAIN.val);
        }

      });

    } else {
      setDlgConf(new Fnc.DlgConf("[EMPDOM] Dominio non valido", "Inserisci un dominio valido prima di procedere", false, "Chiudi", ""));
      Fnc.gaException("[ConfigurazioneSito.js@gotoNext] Impossibile salvare il dominio, dominio non valido", JSON.stringify(currDomain), false, Fnc.ExcCatgory.DOMAIN.val);
    }
  }

  function resetDomain() {
    setSelectedExt(".it");
    setCurrDomain("");
    setDomainOk(null);
  }

  function btnRelClick(e) {
    let domVal = e.target.value;
    let domParts = domVal.split('.');
    setSelectedExt("." + domParts[1]);
    setCurrDomain(domParts[0]);
    checkDomain(domVal);
  }

  return (
    <>
      <div className="iol-checkout-left-part col-xl-7 checkout-card checkout-domain-card"><p className="heading-3">Scegli il dominio per il tuo sito</p>
        <div className="iol-choose-domain-wrapper row">
          <div className="iol-choose-domain-input col-md-10"><span className="iol-suffix">http://www.</span>
            <input type="text" name="inputdomain" id="inputdomain" placeholder="c" onChange={onDomainChange} value={currDomain && currDomain !== null ? currDomain : ""} disabled={domainOk} />
            {domainOk === true ?
              <div className="icon-accepted-domain"></div>
              :
              <div className="icon-rejected-domain"></div>
            }
          </div>
          {/*
          <div className="iol-choose-domain-input col-md-10"><span className="iol-suffix">http://www.</span><input type="text" name="inputdomain" id="inputdomain" placeholder="c" />
            <div className="icon-rejected-domain"></div>
          </div>*/}
          <div className="iol-choose-domain-select col-md-2">
            <div className="select-domain">
              <div className="select-domain__current" tabIndex="1">
                {extDomainsAvailable.map((ext, index) => (
                  <div className="select-domain__value">
                    <input className="select-domain__input" type="radio" id={index} value={ext} name="Domains" checked={selectedExt === ext || !selectedExt} onChange={onSelExtension} disabled={domainOk} />
                    <p className="select-domain__input-text">{ext}</p>
                  </div>
                ))}

                {domainOk !== true ?
                  <img className="select-domain__icon" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE0IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNMSAxLjc2MDc0TDcgNy43NjA3NEwxMyAxLjc2MDc0IiBzdHJva2U9IiMxODFCMzEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg==" alt="Arrow Icon" aria-hidden="true" />
                  :
                  <></>
                }
              </div>
              <ul className="select-domain__list">
                {extDomainsAvailable.map((ext, index) => (
                  <li><label className="select-domain__option" htmlFor={index}>{ext}</label></li>
                ))}
              </ul>
            </div>
          </div>
          {domainOk === false && <div className="iol-wrong-domain fucsia-text semibold">Il dominio selezionato non è disponibile</div>}
        </div>


        {(relatedDomains && relatedDomains !== null && relatedDomains.length > 0) &&
          <>
            <p className="heading-3">Altri domini simili</p>
            <div className="iol-similar-domains-wrapper">
              {relatedDomains.map((dom, index) => (
                <div className="iol-similar-domain-wrapper row">
                  <div className="iol-similar-domain-text col-md-9">
                    <div className="iol-similar-domain">{dom.name}<span className="iol-dot">.{dom.ext}</span></div>
                  </div>
                  <button className="iol similar-domain-button col-md-3" value={dom.name + "." + dom.ext} onClick={btnRelClick}>seleziona dominio</button>
                </div>
              ))}
            </div>
          </>
        }

        <div className="iol-accepted-domain-wrapper">
          {domainOk === true &&
            <>
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAVQSURBVHgB7ZtNaxtXFIbPnQ9Ba0PlUogpLVWaLNpNLIMVbDlQZVHILll0XwWslkDB8q47y7+gNhRC4oLlf9DsCllECytx7YDVrpvGoRScTaKADUHSzM05oxmhSWZGo/kekQfkkUYjWe8759577heDkLn9aDEnikJJZGxOAZ5jwHKc8yxjLDd8HZ47xnNtDvyYq/AXiLyldnnr1tL+MYQIgxC4fbhYyoB4XeH8xttCx4UxOMZDo8uV3VuF/QYETGAG7ByVsr1eZxW/soovsxACZIaq8g1FURtBRYZvA6IQbkEbH/VeT9nya4QvA+4eLK0yJtQgOuEmjIj44fLDOnjEkwFUsUmSuINPS5AAyIhuV7nqJRoEGBO66yj+CBIinuAc6IYc3dlfqo750fEiYPtw+Rc8jP1PooXXKoWHG26vdm3Ab4+Xd9DpMqQALBL1lYXmTVfXurkI7zyFfB7SRatSaM6PumhkHUB3HtInnsjrv90RRwO2D4vraQl7K+i36/WWLbZFQG/jN2ECUBV17cfFR5ZaLA3Q23kq97EkOCHQxqxx3ipPsCwC2Ht7AJMjnsjqids7vGPA3YNi2W8PLqGUrBIlUxHQ++4PJtQAoi1J8vmb8422ccIUARgmqxMsnsh2Oh1TFAwiYAIrPjtMUSAZZ2nYClImfkqeha8/+Q5mPrwIHeUUHv//K5x1T0Z9zIiCGr2Qht5YhxRB4r+9sAnTmdnBuXNTebj/pAovX//j+FlBYDiA0zdAqwNoDC9NZd9KPJERp+HSbNnNV2S3D6+U6IlmgMzE7yEl2Ik3yAjT4AbO1Rt01AzAYaUSpIBR4gkXdYAGFoPrdGR67f8UEo4b8aedE7j/bxXOOu5MYCLPCbIsJ76rG4Z4Qu3BVUFRlEQbEJZ4nbwgCjAHCSVk8VgTQg4rQZYDH8hY6858cFE7Bkno4hEmsC8ktT9RCV74CrOwS+fKWvtL/P28rj38EoV4AmVnBa8JEN31hU9/GognyIziZz+DH6IST/B+EfDGhZlrlue//PiaZxOiFG/g2QAnvJgQh3jCswH/vdpzfH8cE+ISTwi0MgM88PysNbLCc2NCnOJpUhVTYtYGj7ip9Z1MiFM8gZVgG4uAtwgw8GpC3OIJrvJngsrhGfhkXBOSIJ7gOH9II0ItCADDAMoF7CATZLGfOcYtXkPkLYkWHGF3GILAjQmff3QFnIhMPELL8LQcGCdDngY5JEYGOJlgR5TiqQVYWWieN/KAexAgXvoEUYrXadAfzQCcBf4dAmYcE2IQj00g26XjoBuI8+gvIYR5gVHFIQ7xRvjT80EqjAOjWxACTpEQh3iC1hYazwcGZDIZWkDgOSt0wsqEuMQjbWr5jBemkZA7fxZrmBuHNkM0hW3/7HRem8Y6OW1BF49Rg63d1srC3mCC1NQbDDMKCLrbT178ofUk4xFPK0p7pqUyJgP0GVPXiwzTBpX9t5fJWA4GYotAS2RKMEEM1/zDWA6I9HoKrbIMrSjEQJsWU1u9YWmAHiaTVBQ27FaS2w6JVQrNTaoxIfWwDdJi+y6MYPtguY5XpWb63ASH3crlZtnpkveLpcEF2hehm5AW6M67EE+4HhbvhxJLfMVI9daosB9mrHmBSmGvhoc1SGYTSb9pbTjNdYPnTVMJW1HaoNzFy6Ypn9vmimU8rMdohJa6OzVzo/C9cZKiQZalKs4wUVMZ4cZJtiVJ0ubwul8vBLZ11tgkDeFGRGDCDULZPK0tQuS8zIF/49cMmrvEmvoex3FLrIQbEDChGDBMv4jIeVqMxQSYc7N9XsDZKhUTmSA3SdvxBp9ovKdlOM8iAAAAAElFTkSuQmCC" alt="accepted domain" />
              <div className="iol-domain-accepted-label semibold">Il dominio che hai richiesto è disponibile! </div>
            </>
          }
          {(domainOk === true) ?
            <>
              <button className="fucsia-button" onClick={resetDomain}>Cambia</button>
              <button className="fucsia-button" onClick={gotoNext}>Procedi</button>
            </>
            :
            <button className="fucsia-button" onClick={btnCheckClick}>Verifica disponibilità
              <Loader visible={loading} className="loadingSpinner" type={Fnc.LoadingInp.TYPE} color="#ffffff" height={Fnc.LoadingInp.HEIGHT} width={Fnc.LoadingInp.WIDTH} timeout={Fnc.LoadingInp.TIMEOUT} />
            </button>
          }


        </div>


      </div>
      {dlgConf != null &&
        <DialogMsg conf={dlgConf} ></DialogMsg>
      }
    </>
  );
}

export default ConfigurazioneSito;
